import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { X, CornerDownLeft, FileText, Minus } from './icons';
import { PageBreakIcon } from './PageBreakIcon';
export function PageBreakView({ deleteNode }) {
    return (<NodeViewWrapper className="line-rule-wrapper page-break-wrapper" contentEditable={false}>
      <div className="line-rule-container page-break-container">
        <div className="line-rule-badge page-break-badge">
          <PageBreakIcon size={16} />
          <span>PAGE BREAK (&lt;page break&gt;)</span>
        </div>
        <div className="line-rule-divider"/>
        <button type="button" className="line-rule-remove-btn" onClick={deleteNode} title="Remove Page Break">
          <X size={14}/>
        </button>
      </div>
    </NodeViewWrapper>);
}
export function LineBreakView({ deleteNode }) {
    return (<NodeViewWrapper className="line-rule-wrapper line-break-wrapper" contentEditable={false}>
      <div className="line-rule-container line-break-container">
        <div className="line-rule-badge line-break-badge">
          <CornerDownLeft size={13}/>
          <span>LINE BREAK (&lt;line break&gt;)</span>
        </div>
        <div className="line-rule-divider line-break-line"/>
        <button type="button" className="line-rule-remove-btn" onClick={deleteNode} title="Remove Line Break">
          <X size={14}/>
        </button>
      </div>
    </NodeViewWrapper>);
}
export function HorizontalLineView({ deleteNode }) {
    return (<NodeViewWrapper className="line-rule-wrapper horizontal-line-wrapper" contentEditable={false}>
      <div className="line-rule-container horizontal-line-container">
        <div className="line-rule-badge horizontal-line-badge">
          <Minus size={13}/>
          <span>HORIZONTAL LINE (&lt;line&gt;)</span>
        </div>
        <div className="line-rule-divider horizontal-line-solid"/>
        <button type="button" className="line-rule-remove-btn" onClick={deleteNode} title="Remove Horizontal Line">
          <X size={14}/>
        </button>
      </div>
    </NodeViewWrapper>);
}
